// These values are also used for class names
export enum LinkVariant {
  Primary = 'primary',
  /** @deprecated 19/11/2024 */
  Grey = 'grey',
  /** @deprecated 19/11/2024 */
  Red = 'red',
}
